import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/images/Emma.jpg'


const _hoisted_1 = { class: "auth-wrapper" }
const _hoisted_2 = { class: "right-panel" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  key: 0,
  class: "form-group"
}
const _hoisted_6 = { class: "captcha-container" }
const _hoisted_7 = {
  key: 1,
  class: "message error msg"
}
const _hoisted_8 = {
  key: 2,
  class: "message success msg"
}
const _hoisted_9 = { class: "btn-group" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]

import { ref } from 'vue'
import { supabase } from '../lib/supabase'
import { Session } from '@supabase/supabase-js';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import { useUserStore } from '@/stores/user';
import VueHcaptcha from '@hcaptcha/vue3-hcaptcha';
import { useLoadingStore } from '../stores/loading'


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthSupa',
  setup(__props) {


const loading = ref(false)
const email = ref('')
const password = ref('')
const confirmPassword = ref('')
const errorMessage = ref('')
const successMessage = ref('')
const session = ref<Session | null>(null)
const router = useRouter();
const apiUrl = process.env.VUE_APP_DJANGO_BACKEND
const contactMessage = ref(false);
const isSigning = ref(false)
const showSecondPassword = ref(false)
const hcaptchaKey = process.env.VUE_APP_HCAPTCHA_SITE_KEY
const captchaToken = ref('')
const captchaRef = ref()
const loadingStore = useLoadingStore()

const onCaptchaVerify = (token: string) => {
  captchaToken.value = token
}

const onCaptchaExpired = () => {
  captchaToken.value = ''
}

const resetCaptcha = () => {
  if (captchaRef.value && typeof captchaRef.value.resetCaptcha === 'function') {
    captchaRef.value.resetCaptcha()
  }
}

const handleSignUp = async () => {
  errorMessage.value = ''
  successMessage.value = ''
  contactMessage.value = false

  if (!email.value) {
    errorMessage.value = "Please enter an email address.";
    return;
  }

  if (!password.value) {
    errorMessage.value = "Please enter a password.";
    return;
  }

  if (!isSigning.value) {
    isSigning.value = true
    showSecondPassword.value = true
    successMessage.value = "Please confirm your passowrd."
    return;
  }

  if (!captchaToken.value) {
    errorMessage.value = "Please complete the CAPTCHA."
    return
  }

  if (!confirmPassword.value) {
    errorMessage.value = "Please confirm your password.";
    return;
  }

  if (password.value !== confirmPassword.value) {
    errorMessage.value = "Passwords do not match."
    return
  }
  
  await checkIfUserExists();
  if (errorMessage.value) {
    return;
  }

  try {
    loading.value = true
    loadingStore.setLoading(true)
    const { data, error } = await supabase.auth.signUp({
      email: email.value,
      password: password.value,
      options: {
        captchaToken: captchaToken.value,
      }

    })
    resetCaptcha()
    if (error) { 
      throw error
    }

    successMessage.value = "Account created, check your email";
  } catch (error: any) {
    errorMessage.value = error.message
  } finally {
    loading.value = false
    loadingStore.setLoading(false)
  }
}

const checkIfUserExists = async () => {
  try {
    const response = await fetch(`${apiUrl}/api/users/exists/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: email.value })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data.exists) {
      errorMessage.value = 'User with this email already exists.';
      contactMessage.value = true;
    }
  } catch (error) {
    console.error('Error checking if user exists:', error);
  }
};

const handleSignIn = async () => {

  errorMessage.value = ''
  successMessage.value = ''
  contactMessage.value = false
  
  
  if (isSigning.value) {
    resetForm()
    return;
  }

  const authStore = useAuthStore();
  const userStore = useUserStore();

  if (!email.value) {
    errorMessage.value = "Please enter an email address.";
    return;
  }

  if (!password.value) {
    errorMessage.value = "Please enter a password.";
    return;
  }

  try {
    loading.value = true
    const { data, error } = await supabase.auth.signInWithPassword({ 
      email: email.value,
      password: password.value,
      options: {
        captchaToken: captchaToken.value,
      }
    })
    if (error) throw new Error("Wrong credentials, can't log in? Contact us at support@coloring-ai.art");

    if (!data?.session) {
      throw new Error("No session data returned from supabase.");
    }
    authStore.setSession(data.session)
    userStore.fetchUser()
    router.push('/home')
    resetCaptcha()

  } catch (error: any) {
    errorMessage.value = error.message
  } finally {
    loading.value = false
  }
}

const resetForm = () => {
  isSigning.value = false
  showSecondPassword.value = false
  errorMessage.value = ''
  successMessage.value = ''
  contactMessage.value = false
  email.value = ''
  password.value = ''
  confirmPassword.value = ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"left-panel\"><div class=\"floating-elements\"><div class=\"floating-element\">🌈</div><div class=\"floating-element\">✨</div><div class=\"floating-element\">🎨</div></div><div class=\"brand-content\"><div class=\"brand-logo\"><img src=\"" + _imports_0 + "\" alt=\"Coloring-AI\"></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "auth-header" }, [
        _createElementVNode("a", { href: "/" }, [
          _createElementVNode("h2", { class: "auth-title green" }, "Coloring-AI")
        ]),
        _createElementVNode("p", { class: "auth-subtitle" }, "Sign in to continue :)")
      ], -1)),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label" }, "Email Address", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "form-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            placeholder: "Enter your email",
            required: ""
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label" }, "Password", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            class: "form-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            placeholder: "Enter your password",
            required: ""
          }, null, 512), [
            [_vModelText, password.value]
          ])
        ]),
        (showSecondPassword.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label" }, "Confirm Password", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "form-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmPassword).value = $event)),
                placeholder: "Confirm your password",
                required: ""
              }, null, 512), [
                [_vModelText, confirmPassword.value]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(VueHcaptcha), {
            ref_key: "captchaRef",
            ref: captchaRef,
            sitekey: "679c8406-091a-44a6-b226-f9e48b18167e",
            onVerify: onCaptchaVerify,
            onExpired: onCaptchaExpired
          }, null, 512)
        ]),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        (successMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(successMessage.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            onClick: handleSignIn,
            disabled: loading.value
          }, _toDisplayString(loading.value ? 'Loading...' : 'Login'), 9, _hoisted_10),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: handleSignUp,
            disabled: loading.value
          }, " Sign Up ", 8, _hoisted_11)
        ])
      ], 32)
    ])
  ]))
}
}

})